import React from "react";
import Skeleton from "../shared/skeleton-component";

const EligibilityFailedPostpaidSkeleton = () => {
  return (
      <div className="eligibility-plan-card-container">
        {new Array(2).fill("").map((_, index) => {
          return (
            <div key={index} className="storefront-card-skeleton">
              <Skeleton
                width={"250px"}
                height={"300px"}
                mobWidth={"40vw"}
                mobHeight={"200px"}
              />
            </div>
          );
        })}
      </div>
  );
};

export default EligibilityFailedPostpaidSkeleton;
